@mixin mobile() {
  @media (max-width: 767px) {
    @content;
  }
}

.card {
  border-radius: 12px;
  padding: 22px;
  overflow: hidden;
  @include themify($themes) {
    background-color: themed("main-secondary");
    border: 1px solid themed("neutral-secondary");
  }

  .subtitle {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    @include themify($themes) {
      color: themed("neutral-primary");
    }

    &.withIcon {
      display: flex;
      align-items: center;
      column-gap: 4px;
      justify-content: flex-start;
      white-space: nowrap;
    }
  }
}

.loading {
  animation-duration: 1.8s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: loader;
  animation-timing-function: linear;
  background-size: 1000px 640px;
  position: relative;
  @include themify($themes) {
    background-image: linear-gradient(
      to right,
      rgba(themed("neutral-tertiary"), 0.5) 8%,
      rgba(themed("neutral-secondary"), 0.5) 38%,
      rgba(themed("neutral-tertiary"), 0.5) 54%
    );
  }
  @include dark-mode() {
    @include themify($themes) {
      background-image: linear-gradient(
        to right,
        rgba(themed("neutral-tertiary"), 0.5) 8%,
        rgba(themed("neutral-primary"), 0.5) 38%,
        rgba(themed("neutral-tertiary"), 0.5) 54%
      );
    }
  }
  @keyframes loader {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }

  &.textLoader {
    height: 23px;
    margin-top: 5px;
    width: 60px;
    border-radius: 6px;
  }
}

.header {
  font-weight: 500;
  margin: 0 0 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  h2 {
    font-weight: 500;
    font-size: 24px;
    line-height: 24px;
    margin: 0;
  }

  @include themify($themes) {
    color: themed("main-primary");
  }
  @include mobile() {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 25px;
    h2 {
      margin-top: 10px;
    }
  }
}

.tooltip {
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  padding: 5px;
  border-radius: 11px;
  @include themify($themes) {
    color: themed("main-primary");
    box-shadow: 0px 5px 7px themed("shadow");
    background-color: themed("neutral-tertiary");
    border: 1px solid themed("neutral-secondary");
  }

  &.chartjsTooltip {
    position: absolute;
    pointer-events: none;
    z-index: 1000;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
}

.moreInfoQuestionMark {
  height: 12px;
  width: 12px;
  flex-shrink: 0;
}

.interactionsToolTip {
  width: 200px;
}

.metricIsZero {
  opacity: 0.5;
}

.container {
  padding: 24px 30px;
  max-width: 1920px;
  margin: 0 auto;
  width: 100%;
}

.searchInput {
  width: 260px;

  input {
    height: 36px;
    border-radius: 20px;
    font-size: 15px;
    padding-left: 45px;
    @include themify($themes) {
      border: 1px solid themed("neutral-secondary");
      background-color: themed("main-secondary");
    }

    &:active,
    &:focus {
      @include themify($themes) {
        border: 1px solid themed("main-primary");
      }

      svg {
        opacity: 1;
      }
    }
  }

  svg {
    opacity: 0.75;
  }

  .clearAllContainer {
    background: transparent;
  }
}
